import { render, staticRenderFns } from "./GroupsCreate.vue?vue&type=template&id=75a350de&"
import script from "./GroupsCreate.vue?vue&type=script&lang=js&"
export * from "./GroupsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports